import InfoHeader from "./infoHeader.container";

export default InfoHeader;